import React, { useEffect, useState } from "react";
import apiClient from "../../actions/api";
import isEmpty from "../../validations/is-empty";

// import sections
import HeroSection from "./sections/HeroSection";
import JobsSection from "./sections/JobsSection";
import BandSection from "./sections/BandSection";
import LoadingJobsSection from "./sections/LoadingJobsSection";

const Careers = ({ title }) => {
  useEffect(() => {
    const original = document.title;
    document.title = title + " | " + original;
    return () => {
      document.title = original;
    };
  }, [title]);

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState([]);
  const [count, setCount] = useState(0);

  const getJobs = async () => {
    setLoading(true);

    await apiClient
      .get("/candidates/get-published-jobs")
      .then(async (res) => {
        if (isEmpty(res.data?.result)) {
          setResult([]);
          setCount(0);
        } else {
          setResult(res.data?.result);
          setCount(res.data?.result.length);
        }

        setLoading(false);
      })
      .catch((err) => {
        if (!isEmpty(err?.response?.data?.errors)) {
          err.response.data.errors.forEach((item) => {
            console.log(item.msg);
          });
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    getJobs();
  }, []);

  return (
    <div>
      <HeroSection count={count} />
      {loading ? (
        <LoadingJobsSection content="Loading open roles" />
      ) : (
        <JobsSection result={result} />
      )}
      <BandSection />
    </div>
  );
};

export default Careers;
